<template>
  <teleport
    v-if="!IS_SSR && toastNotifications?.length"
    to="body"
  >
    <component-wrapper
      :class="{
        'toast-notification-fi': true,
        'toast-notification-fi--offset-top-large': isSnackbarVisible,
        ...headerHeightClasses,
      }"
    >
      <grid-container-fi>
        <toast-notification-item-fi
          v-for="toast in toastNotifications"
          :key="toast.name"
          :toast="toast"
        />
      </grid-container-fi>
    </component-wrapper>
  </teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import ToastNotificationItemFi from '@/components/notifications-fi/toast-notification-fi/toast-notification-item-fi/ToastNotificationItemFi.vue';
import { useHeaderHeight } from '@/composables/headerHeight';

defineOptions({
  name: 'ToastNotificationFi',
});

const { headerHeightClasses } = useHeaderHeight();
const store = useStore();

const isSnackbarVisible = computed<boolean>(() => store.getters['notifications/snackbarVisible']);
const toastNotifications = computed(() => store.getters['notifications/getToastNotifications']);
</script>

<style src="./toast-notification-fi" />
